export default "<div id=\"no1\">\n  <ng-content select=\"[no1]\"></ng-content>\n</div>\n<div id=\"no2\">\n  <ng-content select=\"[no2]\"></ng-content>\n</div>"